import React from 'react';
import AIBootcampSalesPage from './AIBootcampSalesPage';

const AIBootcamp = () => {
  return <AIBootcampSalesPage />;
};

export default AIBootcamp;
